import {
  Component,
  TemplateRef,
  computed,
  contentChild,
  input,
} from '@angular/core';
import { toDisplayLabel } from '../../utils/label.util';

@Component({
  selector: 'app-primeng-card',
  templateUrl: './primeng-card.component.html',
  styleUrls: ['./primeng-card.component.scss'],
  standalone: false,
})
export class PrimengCardComponent {
  header = input<string | undefined>(undefined);
  subheader = input<string | undefined>(undefined);
  class = input<string | undefined>(undefined);
  styleClass = input<string | undefined>(undefined);

  cardHeader = contentChild<TemplateRef<any>>('cardHeader');
  cardContent = contentChild<TemplateRef<any>>('cardContent');
  cardFooter = contentChild<TemplateRef<any>>('cardFooter');

  hasHeaderRow = computed<boolean>(() => !!(this.header() || this.subheader()));

  /** Safe text for the header title - never renders "[object Object]". */
  headerText = computed<string>(() => toDisplayLabel(this.header()));

  /** Safe text for the header subheading - never renders "[object Object]". */
  subheaderText = computed<string>(() => toDisplayLabel(this.subheader()));
}
